import { render } from "./ColorInput.vue?vue&type=template&id=4647b04c&scoped=true"
import script from "./ColorInput.vue?vue&type=script&lang=js"
export * from "./ColorInput.vue?vue&type=script&lang=js"

import "./ColorInput.vue?vue&type=style&index=0&id=4647b04c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4647b04c"]])

export default __exports__